import * as R from 'ramda'
import {
    TOGGLE_SETTING_SUCCESS,
    TOGGLE_SHARE_SUCCESS,
    TOGGLE_COMMENTS_SUCCESS,
    TOGGLE_LISTS_SUCCESS,
    TOGGLE_LIST_HEADER_SUCCESS,
    TOGGLE_HISTORY_SUCCESS
} from '../actionTypes'

const InitialState = {
    setting: false,
    share: false,
    Lists: false,
    comments: false,
    listHeader: false,
    history: false
};

export default (state = InitialState, {type}) => {

    switch (type) {
        case TOGGLE_SETTING_SUCCESS:
            let setting = {...InitialState, setting: state.setting};
            setting.setting = !setting.setting;
            return setting
        case TOGGLE_SHARE_SUCCESS:
            let share = {...InitialState, share: state.share};
            share.share = !share.share;
            return share
        case TOGGLE_COMMENTS_SUCCESS:
            let comments = {...InitialState, comments: state.comments};
            comments.comments = !comments.comments;
            return comments
        case TOGGLE_LISTS_SUCCESS:
            let lists = {...InitialState, lists: state.lists};
            lists.lists = !lists.lists;
            return lists
        case TOGGLE_HISTORY_SUCCESS:
            let history = {...InitialState, history: state.history};
            history.history = !history.history;
            return history
        case TOGGLE_LIST_HEADER_SUCCESS:
            let listHeader = {...InitialState, listHeader: state.listHeader};
            listHeader.listHeader = !listHeader.listHeader;
            return listHeader

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/dropBox.js